const chartsConfig = {
    lang: {
        contextButtonTitle:"图表导出菜单",
        decimalPoint:".",
        downloadJPEG:"下载JPEG图片",
        downloadPDF:"下载PDF文件",
        downloadPNG:"下载PNG图片",
        downloadSVG:"下载SVG文件",
        printChart:"打印图表",
        drillUpText:"返回上一层",
        // loading:"加载中",
        // months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],
        // noData:"没有数据",
        // numericSymbols: [ "千" , "兆" , "G" , "T" , "P" , "E"],
        // 
        // resetZoom:"恢复缩放",
        // resetZoomTitle:"恢复图表",
        // shortMonths: [ "Jan" , "Feb" , "Mar" , "Apr" , "May" , "Jun" , "Jul" , "Aug" , "Sep" , "Oct" , "Nov" , "Dec"],
        // thousandsSep:",",
        // weekdays: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六","星期天"]
     },
     exporting: {
        menuItemDefinitions: {
            // Custom definition
            label: {
                onclick: function () {
                },
                text: '导出'
            }
        },
        buttons: {
            contextButton: {
                align: "right",
                x: -10,
                y: -5
            }
        },
        chartOptions: {
            legend: {
                padding: 16
            }
        }
     }

}

export default chartsConfig;



// WEBPACK FOOTER //
// ./src/components/common/chartsConfig.js